<template>
	<div class="section__head">
		<h2>
			{{ title }}
		</h2>

		<p>
			{{ description }} <br>
			{{ description2 }}
		</p>
	</div><!-- /.section__head -->
</template>

<script>
export default {
	/**
	 * Component Name.
	 *
	 * @type {String}
	 */
	name: 'the-section-head',

	props:{
		title: {
			type: String,
			defatul() {
				return '';
			}
		},
		description: {
			type: String,
			defatul() {
				return '';
			}
		},
		description2: {
			type: String,
			defatul() {
				return '';
			}
		},
	}
};
</script>

<style>
	.section__head { text-align: center; margin-bottom: 17px; }
	.section__head h2 { font-size: 16px; color: #a27c2c; margin-bottom: 6px; letter-spacing: 2px; text-transform: uppercase; }
	.section__head h2:last-child { margin-bottom: 0; }
	.section__head p { font-size: 16px; font-weight: 700; color: #9b9b9b; }
</style>



// WEBPACK FOOTER //
// src/components/SectionHead.vue